export const AutomationModalPaneOptions = {
  CREATE: 'create',
  EDIT: 'edit',
  LIST: 'list',
} as const;

export const AutomationModalActionType = {
  UPDATE_STATUS: 'update_status',
} as const;

export const AutomationTrigger = {
  QUESTION_ANSWER: 'question_answer',
} as const;

export const AutomationListVariant = {
  READ_ONLY: 'read_only',
  EDITABLE: 'editable',
} as const;
